import { Pill } from '@mantine/core'
import PillControlClasses from './styles.module.css'
import '../../styles/variables.css'

export default Pill.extend({
    defaultProps: { size: 'md' },
    classNames: PillControlClasses,
})
